module.exports = __webpack_public_path__ + "img/block_4l_ove_NY.c040c2e1.png";